import { createContext } from 'react';
import { JobRole } from 'src/models/job-role';

export interface JobRoleContextType {
  getJobRoles: () => JobRole[];
  getMyJobRoles(): JobRole[];
  createJobRole: (jobRole: Omit<JobRole, '_id' | 'organization'>) => Promise<string | null>;
  editJobRole: (jobRole: Partial<JobRole> & { _id: string }) => void;
  deleteJobRole: (jobRoleId: string) => void;
}

export const JobRoleContext = createContext<JobRoleContextType>({} as JobRoleContextType);
